/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import Uri from 'jsuri';

import user from 'js/lib/user';

import { Button } from '@coursera/cds-core';
import type {
  GetSubscriptionPaymentMethodUpdateUrlRequest,
  GetSubscriptionPaymentMethodUpdateUrlResponse,
} from '@coursera/grpc-types-paymentprocessor/coursera/proto/paymentprocessor/v1beta2/subscription_processor_api';

import PageDataContext from 'bundles/my-purchases-graphql/data/PageDataContext';
import type { PageDataContextType } from 'bundles/my-purchases-graphql/data/PageDataContext';
import { TrackedA } from 'bundles/page/components/TrackedLink2';
import subscriptionProcessorApi from 'bundles/payments/api/subscriptionProcessor';
import {
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER,
  PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER_SANDBOX,
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER,
  PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER_SANDBOX,
} from 'bundles/payments/common/PaymentProcessorIdTypes';

import _t from 'i18n!nls/my-purchases-graphql';

const StripeUpdateSubscriptionLink = () => {
  const context = useContext(PageDataContext) as PageDataContextType;

  const { subscription } = context;

  const stripeSubscriptionPaymentInformation = subscription.stripeSubscriptionPaymentInformation;

  if (!stripeSubscriptionPaymentInformation) return null;

  const handleOnClick = () => {
    const getSubscriptionPaymentMethodUpdateUrlUri = new Uri('GetSubscriptionPaymentMethodUpdateUrl');
    const isSandbox = stripeSubscriptionPaymentInformation.isSandBoxTransaction;
    let paymentProcessorId;
    if (stripeSubscriptionPaymentInformation.isStripeBv) {
      paymentProcessorId = isSandbox
        ? PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER_SANDBOX
        : PAYMENT_PROCESSOR_ID_STRIPE_BV_CONSUMER;
    } else {
      paymentProcessorId = isSandbox
        ? PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER_SANDBOX
        : PAYMENT_PROCESSOR_ID_STRIPE_CONSUMER;
    }

    const request: GetSubscriptionPaymentMethodUpdateUrlRequest = {
      paymentProcessorId,
      stripeSubscriptionPaymentMethodUpdateUrlRequest: {
        userId: user.get().id,
      },
    };
    subscriptionProcessorApi
      .post(getSubscriptionPaymentMethodUpdateUrlUri.toString(), { data: request })
      .then((response: GetSubscriptionPaymentMethodUpdateUrlResponse) => {
        const customerPortalUrl = response.stripeSubscriptionPaymentMethodUpdateUrlResponse?.customerPortalUrl;
        if (customerPortalUrl) window.location.href = customerPortalUrl;
      })
      .catch();
  };
  return (
    <Button
      component={TrackedA}
      css={css({
        padding: '0 !important',
        fontWeight: 'normal !important',
        fontSize: '16px',
        textDecorationLine: 'underline !important',
      })}
      size="small"
      variant="ghost"
      onClick={handleOnClick}
      trackingName="stripe_update_payment_method_button"
      data={{ subscriptionId: subscription.id }}
    >
      {_t('Update card')}
    </Button>
  );
};

export default StripeUpdateSubscriptionLink;
